module.exports = __webpack_public_path__ + "static/61391418_1286657201499349_2793897468956246016_o_optimized-6eea987c5ad877b0a025acee13a95cb4.jpg";